/* eslint-disable no-empty-pattern */
/* eslint-disable react-hooks/exhaustive-deps */
import { isBefore } from "date-fns";
import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import useWorker from "~hooks/useWorker";
import { useGetSimuladorSolicitacoes } from "~pages/Simulators/hooks/useSimulatorsQuery";

const useSimuladorSolicitacoes = ({ }) => {
  const [simuladorSolicitacoesEnabled, setSimuladorSolicitacoesEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const solicitacoes = useLiveQuery(async () => {
    let data = [];
    await db.simuladorSimulacoes.each((e) => data.push(e));

    return data;
  }, [])

  useEffect(() => {
    setSimuladorSolicitacoesEnabled(true);
  }, []);

  const {data, loading, error} = useGetSimuladorSolicitacoes(simuladorSolicitacoesEnabled);
  useEffect(() => {
    if (data) {
      db.simuladorSimulacoes.bulkPut(data);
    }
    if (!loading) {
      setTimeout(() => setIsLoading(false), 2000);
    }
  }, [data, loading]);

  return { solicitacoes, carregando:isLoading , error };
}

export default useSimuladorSolicitacoes;